import consultationPage from '@/js/pages/consultation/index';
import akiyaKanriPage from '@/js/pages/akiya-kanri/index';

const pages = () => {
    consultationPage();
    akiyaKanriPage();
};

export default pages;
